import { DELIVERY_CHALLAN_TRANSACTION_AVAILABLE_REQUEST, GET_DELIVERY_CHALLAN_TRANSACTIONS_AVAILABLE_TAKA_NO, DELIVERY_CHALLAN_TRANSACTION_AVAILABLE_REQUEST_FAILURE,
  GET_DELIVERY_CHALLAN_AVAILABLE_TRANSACTIONS } from '../types';

const initialState = {
  availableTransactions: [],
  availableTakaNos: [],
  loading: false,
  error: null,
};

const deliveryChallanAvailableTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELIVERY_CHALLAN_TRANSACTION_AVAILABLE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DELIVERY_CHALLAN_AVAILABLE_TRANSACTIONS: {
      return {
        ...state,
        availableTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_DELIVERY_CHALLAN_TRANSACTIONS_AVAILABLE_TAKA_NO: {
      return {
        ...state,
        availableTakaNos: [...action.payload],
        loading: false,
        error: null
      }
    }
    case DELIVERY_CHALLAN_TRANSACTION_AVAILABLE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default deliveryChallanAvailableTransactionReducer;
